export default "__VITE_ASSET__zTzPwcge__"